var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GoBack iconfont icon-fanhui",on:{"click":function($event){return _vm.goBack()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }